<template>
  <nw-form
    :nw-form-value="form"
    @nw-form-input="handleNwFormInput"
    ref="nwForm"
  >
    <b-form-group
      id="Temperature"
      :label="$t('kiosk.temperature')"
      label-for="Temperature"
      label-cols="3"
    >
      <validation-provider
        :name="$t('kiosk.temperature')"
        rules="required|between:20,50"
        #default="{ errors }"
      >
        <b-input-group
          append="℃"
          class="input-group-merge"
        >
          <b-form-input
            id="Temperature"
            :value="form.Temperature"
            @input="v => { form.Temperature = v; emitFormData() }"
          />
        </b-input-group>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </nw-form>
</template>

<script>
import nwFormTaskTypeMixin from "@/views/kiosk/components/kskNursingWork/mixins/nwFormTaskTypeMixin";

export default {
  name: "NwFormBt",
  mixins: [nwFormTaskTypeMixin],
}
</script>

<style scoped>

</style>